export const commonConfig = {
  REACT_APP_SERVICE_URL: window.location.protocol + '//' + window.location.host,

  smartAssist: {
    baseUrl:
      window.location.protocol +
      '//' +
      window.location.host +
      '/smart_assist_documents/v1',
  },

  otel: {
    apiKey: '9044101393a233478baa518ce38b61fa10d16e43', // only required for web
    serviceName: 'pcn',
  },
}
